import { InputNumber } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Questo componente server per permettere di poter inserire valori monetari
 */
const CurrencyInput = ({ defaultValue, disabled = false, label, name, onChange, placeholder, value }) => {

    function onChangeNumber(name, value) {
        onChange({
            target: {
                name,
                value
            }
        });
    }

    return (
        <div className='formComponent'>
            <div className="input-group">
                <label className='input-group-addon'>{label}</label>
                <InputNumber
                    decimalSeparator=','
                    defaultValue={defaultValue}
                    disabled={disabled}
                    name={name}
                    onChange={(value) => onChangeNumber(name, value)}
                    placeholder={placeholder}
                    style={{ width: '100%', borderRadius: 0 }}
                    value={value}
                />
            </div>
        </div>
    );
};

CurrencyInput.propTypes = {
    defaultValue: PropTypes.number,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) 
};

export default CurrencyInput;
